module.exports = __webpack_public_path__ + "static/media/news3.bc7f8a6b.jpg";